export default function SectionHeader({ over, title }) {
  return (
    <div className="mb-4">
      {over && <div className="text-xs uppercase tracking-[0.15em] font-semibold text-bordeaux mb-1.5">{over}</div>}
      <h2 className="font-display text-xl text-marine">{title}</h2>
    </div>
  );
}
